import { render } from "./PoliciesPage.vue?vue&type=template&id=74b85f24&ts=true"
import script from "./PoliciesPage.vue?vue&type=script&lang=ts"
export * from "./PoliciesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Profile/PoliciesPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74b85f24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74b85f24', __exports__)) {
    api.reload('74b85f24', __exports__)
  }
  
  module.hot.accept("./PoliciesPage.vue?vue&type=template&id=74b85f24&ts=true", () => {
    api.rerender('74b85f24', render)
  })

}


export default __exports__